import { render, staticRenderFns } from "./TheVpbxMain.vue?vue&type=template&id=2b9df352&"
import script from "./TheVpbxMain.vue?vue&type=script&lang=js&"
export * from "./TheVpbxMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports